import React from 'react';
import TraceTileFallback from '@/finsight/ui/components/trace/TraceTile/TraceTileFallback';
import CheckUserAccess from 'src/finsight/ui/common/components/CheckUserAccess';
import TileHeaderContent from '@/finsight/ui/components/trace/TraceTile/TileHeaderContent';

const tooltipContent = 'Analyze secondary market liquidity with timely and valuable trading data from '
    + 'TRACE by FINRA.';
const fallBack = <TraceTileFallback tooltipContent={ tooltipContent } />;

interface ITraceTileHeaderProps {
  withChart: boolean,
  userAccessChecks: boolean[],
}

const TraceTileHeader = ({ withChart, userAccessChecks }: ITraceTileHeaderProps) => (
  <CheckUserAccess
    checks={ userAccessChecks }
    fallback={ fallBack }
  >
    <TileHeaderContent withChart={ withChart } />
  </CheckUserAccess>
);

export default TraceTileHeader;
